import { FileModel } from '@/types/common'
import { SuppliersSearchParam, InviteParam } from '../suppliers';

export enum PurchaseType {
    /**
     * Поиск поставщиков.
     */
    SupplierFinder = 1,

    /**
     * Запрос коммерческих предложений.
     */
    CommercialOffersRequest = 2,
    /**
     * Создание субподрядов.
     */
    Subcontracts = 3,
}

export enum ProductCharacteristicTypes {
    /**
     *  Строка.
     */
    String = 1,

    /**
     *  Целое число.
     */
    Integer = 2,

    /**
     *  Число с дробной частью.
     */
    Decimal = 3,

    /**
     *  Логический.
     */
    Boolean = 4,

    /**
     *  Дата.
     */
    Date = 5,

    /**
     *  Файл.
     */
    File = 6
}

export enum FormModeType {
    /**
     * Режим работы формы без исходного товара
     */
    Origin = 1,

    /**
     * Режим работы формы с наличием исходного товара
     */
    ByProduct
}

export enum PurchaserTermsType {
    /**
     * Рассматриваются ТОЛЬКО предложения о поставке/выполнении работ/оказании услуг только на указанных ниже условиях
     */
    CustomerTerms = 1,

    /**
     * Поставщики могут предложить свои условия поставки/ выполнения работ/оказания услуг
     */
    PurchaserTerms = 2
}

export enum ApplicationRequirements {
    /**
     * Скан КП с подписью и печатью
     */
    CommercialOfferPhotoCopy = 1,

    /**
     * Электронная форма с ЭЦП
     */
    SignedDigitalForm = 2
}

export interface ProductMainInfo {
    ProductName?: string;
    ProductSource?: string;
    ProductId: number;
    ProductUrl?: string;
    ImageUrl?: string;
    Price: number;
    UnitCode: string;
    UnitName: string;
    UnitShortName: string;
    CurrencyCode?: string;
    Quantity: number;
    TaxPercent: number;
    SearchKeyword?: string | Array<string>;
    SearchQuery?: string;
    Okpd2: string;
    Okpd2Code: string;
    Okved2: string;
    Okved2Code: string;
    Category?: string;
    DeliveryAddress?: DeliveryAddress[];  // ?????
    SupplierOrganization?: SupplierOrganization;
    ProductCharacteristic: ProductCharacteristic[];
    WidgetData?: any;
    IsUnitPrice?: boolean;
}

export interface DeliveryAddress {
    Name: string;
    Code: string;
}

export interface Project /*Trade/TradeLot*/ {
    Id: number;
    Name: string;
    Items: ProjectItem[];
    ApplicationEndDateInner: Date;
    ApplicationEndDateTimeZoneId: number;
    PurchaserTermsType: PurchaserTermsType;
    Properties: ProjectProperties;
    Additional: {
        Files?: FileModel[];
        Text: string;
        ApplicationRequirements?: ApplicationRequirements;
    };
    InvitedOrganizations?: OrganizationInfo[];
    DeliveryAddress?: string;
    DeliveryAddressOkato?: string;
}

export interface ProjectItem /*LotItem*/ {
    Id: number;
    Name: string;
    FullName: string;
    UnitCode: string;
    UnitShortName: string;
    UnitName: string;
    Amount: number;
    Price?: number | null;
    Budget?: number;
    TaxPercent?: number | null;
    Okpd2Name: string;
    Okpd2: string;
    Okved2Name: string;
    Okved2: string;
    ProductId: number;
    DeliveryAddress: string;
    DeliveryAddressOkato: string;
    //DeliveryAddresses: DeliveryAddress[];
    Characteristics: ProductCharacteristic[];
    WithoutPrice: boolean;
    LocalId?: string;
}

export interface ProductCharacteristic {
    Id?: number;
    Index?: number;
    Name: string;
    UnitCode?: string;
    UnitShortName?: string;
    UnitName?: string;
    Value: ProductCharacteristicValue;
    Comment: string;
    UnitSelectorOpen?: boolean;
    ShowTypeSelector?: boolean;
    TypeSelectorFocused?: boolean;
    NameFocused?: boolean;
    LotItem?: number;
}

export interface ProductCharacteristicValue {
    Type?: ProductCharacteristicTypes;
    Value: any;
    Name?: string;
}

export interface SaveOrUpdateModel {
    ProductMainInfo: ProductMainInfo;
    Project: Project;
}

export interface ProjectProperties {
    Delivery: boolean;
    Prepayment: boolean;
}

export interface ProjectsResponse {
    Projects: Project[];
}

export interface ProjectResponse {
    Project: Project;
}

export interface SupplierOrganization {
    OrganizationName?: string;
    CommonOrganizationId?: number | null;
    Inn?: string;
    Kpp?: string;
    Ogrn?: string;
    Email?: string;
    Phone?: string;
    Address?: string;
}

export interface CustomerInfo {
    UserInfo: AuthenticationToken;
    Organization: Organization;
}

export interface AuthenticationToken {
    IsAuthenticated: boolean;
    CommonUserId: number;
    CommonOrganizationId: number;
}

export interface Organization {
    Name: string;
    PostAddress: string;
}

export interface SaveResult {
    IsSuccess: boolean;
    TradeId?: number;
    ProjectId?: number;
    ErrorMessage?: string;
}

export interface KeyValuePair<T extends string | number> {
    Key: T;
    Value: string;
}

export interface FieldErrorModel {
    error: boolean;
    message: string;
}

export interface ProjectCountResponse {
    ProjectCount: number;
}

export interface StoreParams {
    type: PurchaseType;
}

export interface OrganizationInfo {
    //id: number;
    OrganizationName: string;
    Inn: string;
    Kpp?: string;
    Ogrn?: string;
    Contacts?: Array<OrganizationContact>;
    SearchParams: SuppliersSearchParam;
    InviteParams: InviteParam;
}

export interface OrganizationContact {
    Name: string;
    Position: string;
    Phones: Array<string>;
    Emails: Array<string>;
}

export interface Subcontracts {
    Positions: SubcontractPosition[];
    Project: SubcontractProject;
}

export interface SubcontractProject {
    Id?: number;
    Name?: string;
    Files?: FileModel[];
    AdditionalText?: string;
    ApplicationEndDateInner?: Date;
    ApplicationEndDateInnerMsk?: Date;
    Properties: SubcontractProperties;
    DeliveryAddress: string;
    DeliveryAddressOkato: string;
    KladrCode: string;
    OrderId: number;
    isUpdated?: boolean;
}

export interface SubcontractProjectForEdit {
    Id?: number;
    Name?: string;
    ConvertedDocuments: FileModel[];
    PurchaserTermsType: PurchaserTermsType;
    DeliveryAddress: string;
    DeliveryAddressOkato: string;
    ApplicationEndDateInner?: Date;
    PickupIsPossible: boolean;
    OnlyPostpayment: boolean;
    AdditionalRequirements?: string;
}

export interface SubcontractPosition {
    Category: string;
    ParentCategory: string;
    Description: string;
}

export interface SubcontractProperties {
    Delivery: boolean;
    Prepayment: boolean;
    PurchaserTermsType: PurchaserTermsType;
}

export interface SubcontractsTree {
    Available: SubcontractsAvailable[];
    ExistedSubContracts: SubcontractsAlreadyCreated[];
    KladrCode: string;
}

export interface SubcontractsAvailable {
    Name: string;
    Code: string;
    UnitName: string;
    SubCategories: Subcategory[];
    MinPrice: number;
    TotalOffersCount: number;
}

export interface SubcontractsAlreadyCreated {
    TradeLotId: number;
    CategoryCode: string;
    SubCategoryCode: string;
    Name: string;
    KladrCode: string;
    Okpd2Code: string;
    Okpd2Name: string;
    RequestsWithApplicationsCount: number;
    RequestsWithConfirmedApplicationsCount: number;
    RequestsWithoutApplicationsCount: number;
    QuestionsCount: number;
    ApplicationEndDate: Date;
    ApplicationEndDateMsk: Date;
    IsApplicationStageCompleted: boolean;
    TenderUrl: string;
    EditUrl: string;
    CancelUrl: string;
    Project: SubcontractProject;
}

export interface Subcategory {
    Name: string;
    Code: string;
    TotalOffersCount: number;
    MinPrice: number;
    UnitName: string;
}

export interface SubcontractRequest {
    SupplierOrderId: number;
    KladrCode: string;
    CustomerInfo: object;
}

export interface SubcontractRequestResult {
    IsSuccess: boolean;
    Available?: SubcontractsAvailable[];
    ExistedSubContracts?: SubcontractsAlreadyCreated[];
    ErrorMessage?: string;
}

export interface RegionsKladrListRequestResult {
    Code: string;
    Name: string;
    FullName: string;
    Okato: string;
    PostIndex: string;
}

export interface SubcontractSaveResult {
    CommercialPositionsCount: number;
    CommercialPropositionsCount: number;
    CustomersInvitedCount: number;
}

export interface TradeSaveResult {
    Success: boolean;
    Error: string;
}

export interface SupplierFilter {
    organizationInnNames: [];
    productNames: [];
    okpd2: [];
    okved2: [];
    searchInTenders: boolean;
    searchInGoods: boolean;
    okpd2Down: boolean;
    okpd2Up: boolean;
    takeNameAndСategory: boolean;
    okved2Down: boolean;
    okved2Up: boolean;
    searchInvitedSuppliers: boolean;
    searchInActivitiesLast12Months: boolean;
    isMsp: boolean;
    isAbsentRnp: boolean;
    isNotClosedOut: boolean;
    customers: [];
    regions: [];
    legalRegions: any;
    lastActivityPeriod: any;
    minDeliverySum: number;
    maxDeliverySum: number;
    organizationLevels: [];
    sectionTypes: [];
    organizationTypes: [];
    searchWithLicenseOtc: boolean;
}

export interface SupplierItem {
    name: string;
    inn: string;
    kpp: string;
    ogrn: string;
    okved2Main: string;
    okved2Other: [];
    regionAndTimeZoneInn: string;
    isLiquidated: boolean;
    isInvitee: boolean;
}